import { useState } from "react"
import { NavLink } from "react-router-dom"

import { useUI } from "providers/UIProvider"

import { Flex } from "@chakra-ui/react"

import DashboardCard from "components/UI/organisms/DashboardCard"
import { StyledLi, StyledUl } from "./StyledNavigation"
import { useAppContext } from "providers/AppProvider/AppProvider"
import { IRoles } from "types/shared"

const Navigation = () => {
  const { T } = useUI()
  const { isAdmin, laundry, user } = useAppContext()

  const [headingToggle, setHeadingToggle] = useState<boolean>(false)

  const userRole: string = user?.roles && user.roles[0] || IRoles.WASHER_MANAGER;

  const isQappUser = userRole && [IRoles.QAPP_ADMIN, IRoles.QAPP_MANAGER].includes(userRole as IRoles)

  return (
    <Flex
      width={"100%"}
      justifyContent={"center"}
      alignItems={"center"}
      gap={"20px"}
    >
      <nav>
        <StyledUl>
          {[IRoles.QAPP_ADMIN, IRoles.WASHER_ADMIN].includes(userRole as IRoles) && (
            <StyledLi>
              <NavLink
                to={"/employees"}
                className={({ isActive }) =>
                  isActive && !headingToggle ? "isActive" : ""
                }
              >
                <DashboardCard
                  outerTitle
                  title={T("dashboard.employee")}
                  boxshadow="primary"
                  icon="users"
                  width={"employee_card_width"}
                  height={"employee_card_height"}
                  bg={"white"}
                  borderRadius={"15px"}
                  setHeadingToggle={setHeadingToggle}
                />
              </NavLink>
            </StyledLi>
          )}
          {[IRoles.QAPP_ADMIN, IRoles.QAPP_MANAGER, IRoles.WASHER_ADMIN].includes(userRole as IRoles) && (
            <StyledLi>
              <NavLink to={`${isQappUser ? "/laundries" : `/laundries/${laundry?.id}`}`}>
                {({ isActive }) => (
                  <span className={isActive && !headingToggle ? "isActive" : ""}>
                    <DashboardCard
                      outerTitle
                      title={isQappUser ? T("dashboard.laundries") : T("dashboard.laundry")}
                      boxshadow="primary"
                      icon="warehouse"
                      width={"employee_card_width"}
                      height={"employee_card_height"}
                      bg={"white"}
                      borderRadius={"15px"}
                      setHeadingToggle={setHeadingToggle}
                    />
                  </span>
                )}
              </NavLink>
            </StyledLi>
          )}
          <StyledLi>
            <NavLink
              to="/reservations"
              className={({ isActive }) =>
                isActive && !headingToggle ? "isActive" : ""
              }
            >
              <DashboardCard
                title={T("dashboard.reservations")}
                outerTitle
                boxshadow="primary"
                icon="new_qapp"
                width={"employee_card_width"}
                height={"employee_card_height"}
                bg={"white"}
                borderRadius={"15px"}
                setHeadingToggle={setHeadingToggle}
              />
            </NavLink>
          </StyledLi>
          {[IRoles.QAPP_ADMIN, IRoles.QAPP_MANAGER].includes(userRole as IRoles) && (
            <StyledLi>
              <NavLink to="/transactions">
                {({ isActive }) => (
                  <span className={isActive && !headingToggle ? "isActive" : ""}>
                    <DashboardCard
                      outerTitle
                      title={T("dashboard.transactions")}
                      boxshadow="primary"
                      icon="currency_exchange"
                      width={"employee_card_width"}
                      height={"employee_card_height"}
                      bg={"white"}
                      borderRadius={"15px"}
                      setHeadingToggle={setHeadingToggle}
                    />
                  </span>
                )}
              </NavLink>
            </StyledLi>
          )}
          {[IRoles.QAPP_ADMIN, IRoles.WASHER_ADMIN, IRoles.CASHIER].includes(userRole as IRoles) && (
            <StyledLi>
              <NavLink to="/reports">
                {({ isActive }) => (
                  <span className={isActive && !headingToggle ? "isActive" : ""}>
                    <DashboardCard
                      outerTitle
                      title={T("dashboard.report")}
                      boxshadow="primary"
                      icon="trending_up"
                      width={"employee_card_width"}
                      height={"employee_card_height"}
                      bg={"white"}
                      borderRadius={"15px"}
                      setHeadingToggle={setHeadingToggle}
                    />
                  </span>
                )}
              </NavLink>
            </StyledLi>
          )}
          {isAdmin && (
            <StyledLi>
              <NavLink to="/settings">
                {({ isActive }) => (
                  <span className={isActive && !headingToggle ? "isActive" : ""}>
                    <DashboardCard
                      outerTitle
                      title={T("dashboard.settings")}
                      boxshadow="primary"
                      icon="settings"
                      width={"employee_card_width"}
                      height={"employee_card_height"}
                      bg={"white"}
                      borderRadius={"15px"}
                      setHeadingToggle={setHeadingToggle}
                    />
                  </span>
                )}
              </NavLink>
            </StyledLi>
          )}
          {[IRoles.QAPP_ADMIN, IRoles.QAPP_MANAGER].includes(userRole as IRoles) && (
            <StyledLi>
              <NavLink to="/customers">
                {({ isActive }) => (
                  <span className={isActive && !headingToggle ? "isActive" : ""}>
                    <DashboardCard
                      outerTitle
                      title={T("dashboard.customers")}
                      boxshadow="primary"
                      icon="user"
                      width={"employee_card_width"}
                      height={"employee_card_height"}
                      bg={"white"}
                      borderRadius={"15px"}
                      setHeadingToggle={setHeadingToggle}
                    />
                  </span>
                )}
              </NavLink>
            </StyledLi>
          )}
        </StyledUl>
      </nav>
    </Flex>
  )
}

export default Navigation
